import Container from '@paperstac/ui/lib/Container';
import PageTitle from '@paperstac/ui/lib/PageTitle';
import React from 'react';
import { MyListingsPageContext } from './MyListingsPageProvider';
import { IdentityContext } from '@paperstac/common/lib/components/IdentityProvider';
import useFirestoreSubscribe from '@paperstac/common/lib/hooks/useFirestoreSubscribe';
import { firestore } from '../../../services/firebaseClient';
import LoadingMessage from '../../common/LoadingMessage';
import SelectServicerIntegration from './SelectServicerIntegration';
import { isServicerIntegration } from '../IntegrationsPage/IntegrationsPageProvider';
import SelectServicerLoans from './SelectServicerLoans';

const ServicerLoanImporter = React.memo((props) => {
  const { setShowImporter } = React.useContext(MyListingsPageContext);
  const { uid } = React.useContext(IdentityContext);
  const [servicerIntegrations, setServicerIntegrations] = React.useState(null);
  const [selectedIntegration, setSelectedIntegration] = React.useState(null);
  const [integrations] = useFirestoreSubscribe(firestore.collection('integrations').where('identityId', '==', uid), [
    uid,
  ]);

  const showLoading = !servicerIntegrations;
  const showSelectIntegrations = !showLoading && !selectedIntegration;
  const showSelectLoans = !showLoading && !!selectedIntegration;

  React.useEffect(() => {
    if (!integrations) return;
    setServicerIntegrations(integrations.filter(isServicerIntegration));
  }, [integrations]);

  return (
    <Container>
      <PageTitle my={5} textAlign="left">
        Import Loans From Servicer
      </PageTitle>

      {showLoading && <LoadingMessage />}

      {showSelectIntegrations && (
        <SelectServicerIntegration
          servicerIntegrations={servicerIntegrations}
          setSelectedIntegration={setSelectedIntegration}
          setShowImporter={setShowImporter}
        />
      )}

      {showSelectLoans && <SelectServicerLoans integrationId={selectedIntegration} setShowImporter={setShowImporter} />}
    </Container>
  );
});

ServicerLoanImporter.propTypes = {};

ServicerLoanImporter.defaultProps = {};

ServicerLoanImporter.displayName = 'ServicerLoanImporter';

export default ServicerLoanImporter;
